import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";

function ConfirmDialog({
  open = false,
  title = "Підтвердити дію",
  content = "Ви впевнені?",
  confirmText = "Підтвердити",
  cancelText = "Відмінити",
  loading = false,
  onConfirm = () => {},
  onClose = () => {},
}) {
  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      fullWidth
      maxWidth="xs"
    >
      {title && <DialogTitle>{title}</DialogTitle>}
      {content && (
        <DialogContent>
          <Typography variant="body2">{content}</Typography>
        </DialogContent>
      )}
      <DialogActions>
        <Button onClick={onClose} disabled={loading} color="inherit">
          {cancelText}
        </Button>
        <Button
          onClick={onConfirm}
          disabled={loading}
          variant="contained"
          color="error"
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmDialog;
